import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, message, Pagination, Alert, Button, Select, DatePicker, } from 'antd';
import ReporteService from '../../../services/api/reportes';
import helper from '../../../utils/helper';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import apiConfig from '../../../services/api/config';
import ImprimirModal from '../../../components/ImprimirModal/ImprimirModal';

class IndexPagoPendientes extends Component {
  state = {
    cargando: false,
    reportes: [],
    tipo_servicio_id: '',
    tipo_servicio_formato: 'Todos',
    de: moment().format('YYYY-MM-DD'),
    fecha_fin_temp: moment(),
    a: moment().format('YYYY-MM-DD'),
    fecha_inicio_temp: moment(),
    openImprimirModal: false,
    page: {
      number: 1,
      per_page: 15,
      order_column: 'created_at',
      order_type: 'desc',
      from: 0,
      to: 0,
      last_page: 0,
      total: 0,
      buscar_texto: '',
    },
  };

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(this.handleChangeLocation);
    if (this.props.location && this.props.location.search) {
      const queryString = new URLSearchParams(this.props.location.search);
      if (queryString) {
        const buscar_texto = queryString.get('buscar_texto');
        const configPage = Object.assign({}, this.state.page);
        configPage.buscar_texto = buscar_texto;
        this.setState({
          page: configPage,
        });
      }
    }

    this.cargarPagosPendientes();
  }

  handleChangeSearch = (value) => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = value.target.value;
    this.setState({
      page: configPage,
      buscar_texto: value.target.value
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  handleChangeSearchIcon = () => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = this.state.buscar_texto;
    this.setState({
      page: configPage,
      buscar_texto: this.state.buscar_texto
    }, () => {
      this.cargarPagosPendientes();
    });
  }


  cargarPagosPendientes = (path = undefined) => {
    this.setState({
      cargando: true,
    });

    if (!path || path === undefined) {
      path = `?page=${this.state.page.number}&per_page=${this.state.page.per_page}&order_column=${this.state.page.order_column}&order_type=${this.state.page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
      if (this.state.page && this.state.page.buscar_texto && this.state.page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.page.buscar_texto}`;
      }
    }

    ReporteService.getReportePagos(
      path,
      (page) => {
        if (page && page.data && page.data.length > 0) {
          const configPage = Object.assign({}, this.state.page);
          configPage.from = page.from;
          configPage.to = page.to;
          configPage.last_page = page.last_page;
          configPage.total = page.total;
          configPage.number = page.current_page;
          configPage.per_page = parseInt(page.per_page);
          configPage.buscar_texto = page.buscar_texto ? page.buscar_texto : '';

          this.setState({
            cargando: false,
            reportes: page.data,
            page: configPage,
          });
        } else {
          this.setState({
            reportes: [],
            cargando: false,
          });
        }
      },
      (error, result) => {
        if (error) {
          message.error(error.message);
          this.setState({
            cargando: false,
          });
        }
      }
    );
  };

  handleChangeLocation = (location, action) => {
    const queryString = new URLSearchParams(location.search);
    const buscar_texto = queryString.get('buscar_texto');

    if (buscar_texto && buscar_texto != null) {
      const page = Object.assign({}, this.state.page);

      page.buscar_texto = buscar_texto;

      this.setState({
        page,
      });

      setTimeout(() => {
        this.cargarPagosPendientes();
      }, 10);
    }
  };

  handleChangePerPage = (current, pageSize) => {
    const page = Object.assign({}, this.state.page);
    page.number = current;
    page.per_page = pageSize;
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    this.props.history.push(path);
    this.cargarPagosPendientes(path);
  };

  showTotal = (total) => {
    return `Total ${total} registros`;
  };

  handleClickExportarXLS = () => {
    const page = Object.assign({}, this.state.page);
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
    if (this.state.buscar_texto !== undefined || this.state.buscar_texto !== '') {
      path = `${path}&buscar_texto=${this.state.buscar_texto}`;
    }
    const token =  localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
    const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/reporte/pagos/xls${path}&authorization=${token}&empresa_id=${apiConfig.constants.EMPRESA_ID}`;
    window.open(url_exportar);
  };

  handleChangeTipo = (value, opt) => {
    this.setState({
      tipo_servicio_id: value,
      tipo_servicio_formato: opt.label
    }, () => {
      this.cargarPagosPendientes();
    });
  };

  onChangeInicio = (value) => {
    this.setState({
      de: value.format('YYYY-MM-DD'),
      fecha_inicio_temp: value
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  onChangeFin = (value) => {
    this.setState({
      a: value.format('YYYY-MM-DD'),
      fecha_fin_temp: value
    }, () => {
      this.cargarPagosPendientes();
    });
  }

  handleExportar = (value) => {
    const page = Object.assign({}, this.state.page);
    const empresa_id =apiConfig.constants.EMPRESA_ID;
    const token = null;
    let printPDFUrl = null;

    if (value === '1') {
      printPDFUrl = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/forma-pago?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}`;
    } else {
      printPDFUrl = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/tipo-servicios?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&tipo_servicio_id=${this.state.tipo_servicio_id}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}`;
    }
    if (this.state.buscar_texto !== undefined || this.state.buscar_texto !== '') {
      printPDFUrl = `${printPDFUrl}&buscar_texto=${this.state.buscar_texto}`;
    }

    this.setState({
      printPDFUrl,
      openImprimirModal: true
    })
  }

  handleClickCloseImprimirModal = (value) => {
    this.setState({
      openImprimirModal: false
    })
  }


  render() {
    const columns = [
      {
        title: 'Doc. Identidad',
        dataIndex: 'numero_documento',
        key: 'numero_documento',
        responsive: ['lg', 'xl'],
      },
      {
        title: 'Cod. Colegiatura',
        dataIndex: 'codigo_afiliado',
        key: 'codigo_afiliado',
        responsive: ['lg', 'xl'],
        ellipsis: true,
      },      
      {
        title: 'Colegiado',
        dataIndex: 'nombres',
        key: 'nombres',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Fecha Pago',
        dataIndex: 'fecha_pago',
        key: 'fecha_pago',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Fecha Vencimiento',
        dataIndex: 'fecha_vencimiento',
        key: 'fecha_vencimiento',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Nro Comprobante',
        dataIndex: 'numero_comprobante',
        key: 'numero_comprobante',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
    ];

    return (
      <div>
        <div className="page-header">
          <h2 className="page-header">Reporte de pagos de contadores</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 6 }}>
            <div className="topnav__search">
              <input
                type="text"
                placeholder="Buscar..."
                onChange={this.handleChangeSearch}
                value={ this.state.buscar_texto }
              />
              <i onClick={() => this.handleChangeSearchIcon()} className="bx bx-search" style={{cursor: 'pointer'}}></i>
            </div>
            <div>
              <Select
              value={this.state.tipo_servicio_id}
                onChange={this.handleChangeTipo}
                style={{ width: 200 }}
                options={[
                  {
                    value: '',
                    label: 'Todos',
                  },
                  {
                    value: 'CuotaOrdinaria',
                    label: 'Cuota Ordinaria',
                  },
                  {
                    value: 'Capacitaciones',
                    label: 'Capacitaciones',
                  },
                  {
                    value: 'HabilitacionDeColegiatura',
                    label: 'Habilitación de Colegiatura',
                  },
                  {
                    value: 'FondoMutual',
                    label: 'Fondo Mortuorio',
                  },
                  {
                    value: 'FondoMutualDeFallecido',
                    label: 'Fondo Mortuorio Fallecido',
                  },
                  {
                    value: 'AdelantoFondoMutual',
                    label: 'Adelanto Fondo Mortuorio',
                  },
                  {
                    value: 'Fraccionamiento',
                    label: 'Fraccionamiento',
                  },
                ]}
              />
            </div>
            <div>
            <DatePicker value={this.state.fecha_inicio_temp} format={'DD/MM/YYYY'} onChange={this.onChangeInicio} />
            </div>
            <div>
            <DatePicker value={this.state.fecha_fin_temp} format={'DD/MM/YYYY'} onChange={this.onChangeFin} />
            </div>
            <div>
              <Button onClick={this.handleClickExportarXLS} type="primary" shape="round" icon={<DownloadOutlined />} size={null}>
                Descargar Excel
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {!helper.tienePermiso(this.props.permisos, 'Ver registro pagos pendientes') ? (
                <Alert
                  message="Permiso"
                  description="No tiene permiso para ver lista de pagos pendientes"
                  type="error"
                />):
                <div className="card__body">
                  <Table
                    rowKey={(record, index) => index}
                    columns={columns}
                    dataSource={this.state.reportes}
                    pagination={false}
                    loading={this.state.cargando}
                    size="small"
                  />
                  <div style={{ paddingTop: 12, textAlign: 'right' }}>
                    <Pagination
                      size="small"
                      showTotal={this.showTotal}
                      total={this.state.page.total}
                      current={this.state.page.number}
                      pageSize={this.state.page.per_page}
                      onChange={this.handleChangePerPage}
                      onShowSizeChange={this.handleChangePerPage}
                      pageSizeOptions={[10, 20, 30, 40]}
                      showQuickJumper
                      showSizeChanger
                    />
                  </div>
                </div>
              }              
            </div>
          </div>
        </div>
        {this.state.openImprimirModal ? (
          <ImprimirModal
            visible={this.state.openImprimirModal}
            onCancel={this.handleClickCloseImprimirModal}
            url={this.state.printPDFUrl}
            mime_type="application/pdf"
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisos: state && state.user && state.user.permisos.length > 0 ? state.user.permisos : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexPagoPendientes);
